import { faAngleRight, faArrowLeftLong, faArrowRightFromBracket, faBuildingColumns, faChartLine, faCircleLeft, faCircleRight, faCubes, faFile, faFileInvoice, faFileInvoiceDollar, faGear, faHeadset, faIdCard, faMoneyBillTransfer, faMoneyCheckDollar, faPlus, faUserPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react'
import { Link, NavLink } from 'react-router-dom';
import { getAuthProps, signOut } from '../../utils/AuthenticationLibrary';
import AuthenticationServices from '../../services/axiosServices/apiServices/AuthenticationServices';

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.authServices = new AuthenticationServices();
        this.state = {
            isExpand: true,
            currentLevel: 1,
            currentMainModuleId: null,
            currentParentSubModuleId: null,
            companyName: '',
            mainModules: [],
            subModules: [],
            navigationPath: []
        };
    }

    componentDidMount = () => {
        localStorage.removeItem('balanceSheetReportDetails')
        localStorage.removeItem('ledgerReportDetails')
        localStorage.removeItem('accountHeadSummary')
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ companyName: prop.companyName }, () => {
                if (prop.roleId) {
                    this.getSidebarModules(prop.roleId);
                }
            });
        }
        this.restoreNavigationState();
    }

    getSidebarModules = (roleId) => {
        this.authServices.getSidebarModules(roleId).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let modulesAndAccessList = response.responseItem.responseContent;
                this.setState({
                    mainModules: modulesAndAccessList[0] || [],
                    subModules: modulesAndAccessList[1] || []
                });
            }
        });
    }

    restoreNavigationState = () => {
        const level = localStorage.getItem('CurrentLevel');
        const mainModuleId = localStorage.getItem('CurrentMainModuleId');
        const parentSubModuleId = localStorage.getItem('CurrentParentSubModuleId');

        if (level) {
            this.setState({
                currentLevel: Number(level),
                currentMainModuleId: mainModuleId ? Number(mainModuleId) : null,
                currentParentSubModuleId: parentSubModuleId ? Number(parentSubModuleId) : null
            });
        }
    }

    saveNavigationState = () => {
        localStorage.setItem('CurrentLevel', this.state.currentLevel);
        localStorage.setItem('CurrentMainModuleId', this.state.currentMainModuleId || '');
        localStorage.setItem('CurrentParentSubModuleId', this.state.currentParentSubModuleId || '');
    }

    goToFirstLevel = () => {
        this.setState({
            currentLevel: 1,
            currentMainModuleId: null,
            currentParentSubModuleId: null,
            isExpand: false
        }, () => {
            this.saveNavigationState();
        });
    };

    goToSecondLevel = (mainModule) => {
        this.setState({
            currentLevel: 2,
            currentMainModuleId: mainModule.mainModuleId,
            currentParentSubModuleId: null,
            isExpand: true
        }, () => {
            this.saveNavigationState();
        });
    };

    goToThirdLevel = (subModule) => {
        this.setState({
            currentLevel: 3,
            currentParentSubModuleId: subModule.subModuleId,
            isExpand: true
        }, () => {
            this.saveNavigationState();
        });
    }

    goToPrevLevel = () => {
        localStorage.removeItem('balanceSheetReportDetails')
        localStorage.removeItem('ledgerReportDetails')
        localStorage.removeItem('accountHeadSummary')
        this.setState((prevState) => ({
            currentLevel: prevState.currentLevel - 1,
            currentParentSubModuleId: prevState.currentLevel === 3 ? null : prevState.currentParentSubModuleId
        }), () => {
            this.saveNavigationState();
        });
    };

    sidebarExpand = () => {
        this.setState({ isExpand: !this.state.isExpand })
    }

    getLevel2Modules = () => {
        return this.state.subModules.filter(sub =>
            sub.mainModuleId === this.state.currentMainModuleId &&
            !sub.parentSubModuleId &&
            sub.viewPerm === true
        ).sort((a, b) => a.orderId - b.orderId);
    }
    getLevel3Modules = () => {
        return this.state.subModules.filter(sub =>
            sub.parentSubModuleId === this.state.currentParentSubModuleId &&
            sub.viewPerm === true
        ).sort((a, b) => a.orderId - b.orderId);
    }

    // Check if a submodule has children
    hasChildren = (subModuleId) => {
        return this.state.subModules.some(sub => sub.parentSubModuleId === subModuleId);
    }

    // Get icon for main module (you can map these based on mainModuleId or mainModuleName)
    getMainModuleIcon = (moduleName) => {
        const iconMap = {
            'Stock master': faUserPen,
            'Account master': faBuildingColumns,
            'Transaction stock': faMoneyCheckDollar,
            'Transaction account': faMoneyBillTransfer,
            'Other forms': faFile,
            'Master reports': faIdCard,
            'Transaction reports': faFileInvoiceDollar,
            'Stock reports': faCubes,
            'Account reports': faFileInvoice,
            'Utility': faGear
        };
        return iconMap[moduleName] || faChartLine;
    }

    render() {
        return (
            <>
                {this.state.currentLevel === 1 && (
                    <div className={`sidebar${this.state.isExpand ? '' : 'Expand'} bg-white h-[100vh] shadow-normalShadow grid grid-rows-[auto_1fr_auto] content-between mr-[20px]`}>
                        <div className='sidebar-top w-full bg-blue flex justify-between items-center h-fit px-[10px] py-[10px] border-b border-blue'>
                            <span className='text-[18px] font-bold text-[#ebf3ff] rounded-[14px] transition-all duration-300 ease-linear'>
                                {this.state.companyName || ''}
                            </span>
                            <button
                                className='w-[30px] h-[30px] flex items-center justify-center text-white hover:bg-white hover:text-blue hover:rounded-[4px]'
                                onClick={this.sidebarExpand}
                            >
                                <FontAwesomeIcon className='w-[20px] h-[20px]' icon={this.state.isExpand ? faCircleLeft : faCircleRight} />
                            </button>
                        </div>

                        <div className='sidebar-middle w-full p-[10px]' style={{ height: "calc(100vh - 240px)" }}>
                            <div className='middle-inner w-full flex flex-col gap-[4px]'>
                                <NavLink className="level-1 relative" to="/dashboard">
                                    <FontAwesomeIcon icon={faChartLine} />
                                    <span className='transition-all duration-300 ease-linear'>Dashboard</span>
                                </NavLink>

                                {this.state.mainModules.map((mainModule) => (
                                    <Link
                                        key={mainModule.mainModuleId}
                                        className="level-1 relative"
                                        onClick={() => this.goToSecondLevel(mainModule)}
                                    >
                                        <FontAwesomeIcon icon={this.getMainModuleIcon(mainModule.mainModuleName)} />
                                        <span className='transition-all duration-300 ease-linear'>
                                            {mainModule.mainModuleName}
                                        </span>
                                        <FontAwesomeIcon icon={faPlus} />
                                    </Link>
                                ))}
                            </div>
                        </div>

                        <div className='sidebar-bottom h-fit p-[10px]'>
                            <div className='support-sec bg-lightBlue p-[10px] mx-[10px] rounded-[24px] relative'>
                                <img className='absolute w-[100px] top-[-18%] left-[15%]' src='/support-img.png' alt='Support' />
                                <button className='prm-btn w-full mt-[50px] justify-center !py-2.5 !px-5'>
                                    <FontAwesomeIcon icon={faHeadset} />
                                    <span>Support</span>
                                </button>
                            </div>
                            <button className='prm-btn w-[230px] mx-[10px] mt-[10px] justify-center !py-2.5 !px-5' onClick={() => signOut()}>
                                <FontAwesomeIcon icon={faArrowRightFromBracket} />
                                <span>Log out</span>
                            </button>
                        </div>
                    </div>
                )}

                {this.state.currentLevel === 2 && (
                    <div className='sidebar bg-white w-[270px] h-[100vh] shadow-normalShadow grid content-between mr-[20px]'>
                        <div className='sidebar-top bg-blue flex justify-between items-center px-[10px] py-[10px] border-b border-blue'>
                            <span className='text-[18px] font-bold text-[#ebf3ff] rounded-[14px] transition-all duration-300 ease-linear'>
                                {this.state.companyName || ''}
                            </span>
                            <button
                                className='w-[30px] h-[30px] flex items-center justify-center text-white hover:bg-white hover:text-blue hover:rounded-[4px]'
                                onClick={this.goToFirstLevel}
                            >
                                <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faCircleLeft} />
                            </button>
                        </div>

                        <div className='sidebar-middle flex flex-col gap-y-[4px] overflow-y-auto w-full p-[10px]' style={{ height: "calc(100vh - 115px)" }}>
                            {this.getLevel2Modules().map((subModule) => {
                                const hasSubItems = this.hasChildren(subModule.subModuleId);

                                return (
                                    <div key={subModule.subModuleId} className="middle-inner w-full grid gap-[5px]">
                                        {hasSubItems ? (
                                            <Link
                                                className="level-2"
                                                onClick={() => this.goToThirdLevel(subModule)}
                                            >
                                                <span>{subModule.subModuleName}</span>
                                                <FontAwesomeIcon icon={faAngleRight} />
                                            </Link>
                                        ) : (
                                            <NavLink
                                                to={`/${subModule.routePath || '#'}`}
                                                className="level-2"
                                            >
                                                <span>{subModule.subModuleName}</span>
                                            </NavLink>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        <div className='sidebar-bottom h-fit p-[10px]'>
                            <button
                                className='secondary-btn w-[230px] mx-[10px] justify-center'
                                onClick={this.goToPrevLevel}
                            >
                                <FontAwesomeIcon icon={faArrowLeftLong} />
                                Back
                            </button>
                        </div>
                    </div>
                )}

                {this.state.currentLevel === 3 && (
                    <div className='sidebar bg-white w-[270px] h-[100vh] shadow-normalShadow grid content-between mr-[20px]'>
                        <div className='sidebar-top bg-blue flex justify-between items-center px-[10px] py-[10px] border-b border-blue'>
                            <span className='text-[18px] font-bold text-[#ebf3ff] rounded-[14px] transition-all duration-300 ease-linear'>
                                {this.state.companyName || ''}
                            </span>
                            <button
                                className='w-[30px] h-[30px] flex items-center justify-center text-white hover:bg-white hover:text-blue hover:rounded-[4px]'
                                onClick={this.goToFirstLevel}
                            >
                                <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faCircleLeft} />
                            </button>
                        </div>

                        <div className='sidebar-middle flex flex-col gap-y-[4px] overflow-y-auto w-full p-[10px]' style={{ height: "calc(100vh - 115px)" }}>
                            {this.getLevel3Modules().map((subModule) => (
                                <div key={subModule.subModuleId} className="middle-inner w-full grid gap-[5px]">
                                    <NavLink
                                        to={`/${subModule.routePath || '#'}`}
                                        className="level-3"
                                    >
                                        <span>{subModule.subModuleName}</span>
                                    </NavLink>
                                </div>
                            ))}
                        </div>

                        <div className='sidebar-bottom h-fit p-[10px]'>
                            <button
                                className='secondary-btn w-[230px] mx-[10px] justify-center'
                                onClick={this.goToPrevLevel}
                            >
                                <FontAwesomeIcon icon={faArrowLeftLong} />
                                Back
                            </button>
                        </div>
                    </div>
                )}
            </>
        )
    }
}

export default Sidebar;